module.exports = __webpack_public_path__ + "static/media/kinaNakhayeko zeya k vayo bhanata .c7f00770.ogg";